import styled from 'styled-components';

export const StyledPriceWithCurrency = styled.div`
  display: inline-flex;
  align-items: baseline;
  color: var(--brand-ink);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  font-weight: 700;
`;

export const StyledCurrencyWrapper = styled.div`
  ${({ theme }) =>
    theme.direction === 'rtl'
      ? 'margin-right: 0.4rem;'
      : 'margin-left: 0.4rem;'}
  color: var(--muted);
  font-weight: 500;
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0.8;
`;
